const initialState = {
  currentView: null,
  preview: null,
};

const mutations = {
  currentView(state, to) {
    Object.assign(state, { currentView: to });
  },
  preview(state, from) {
    Object.assign(state, { preview: from });
  },
};

const getters = {
  view: (state) => state.currentView,
};

export default {
  state: initialState,
  mutations,
  getters,
};
